module.exports = __webpack_public_path__ + "img/WaterGoldButton.9c35b534.png";